import React from 'react'
import styled from '@emotion/styled'
import { PAGE_BREAKPOINTS } from 'parameters/index'
import { GoTo } from 'ui/inputs/GoTo'
import { TopicCard } from '../TopicCard'
import { Topic } from 'services/ContentfulService/models/topics'

interface Props {
	topics: Topic[]
	title?: string
	linkTo?: string
}

export const TopicsSection: React.FC<React.PropsWithChildren<Props>> = ({ topics, title, linkTo }) => {
	if (topics.length === 0) {
		return null
	}

	return (
		<TopicsWrapper>
			<TopicsContainer>
				<TopicsTop>
					{title && <TopicsTitle>{title}</TopicsTitle>}
					{linkTo && (
						<ShowOnDesktop>
							<GoTo direction="none" href={linkTo}>
								More Topics
							</GoTo>
						</ShowOnDesktop>
					)}
				</TopicsTop>
				<TopicsInnerWrapper>
					{topics.map(topic => (
						<TopicCardHolder key={topic.id}>
							<TopicCard topic={topic} />
						</TopicCardHolder>
					))}
				</TopicsInnerWrapper>
				{linkTo && (
					<ShowOnMobile>
						<TopicsMobileBottom>
							<GoTo direction="none" href={linkTo}>
								More Topics
							</GoTo>
						</TopicsMobileBottom>
					</ShowOnMobile>
				)}
			</TopicsContainer>
		</TopicsWrapper>
	)
}

export const TopicsWrapper = styled.div``

const TopicsContainer = styled.div`
	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		margin: 0 -20px;
		padding: 0;
	}
`

const TopicsTop = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 12px;

	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		padding: 0 20px;
	}
`

const TopicCardHolder = styled.div`
	max-width: 302px;
	width: 100%;

	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		min-width: 302px;
		padding-right: 20px;
	}
`

const TopicsInnerWrapper = styled.div`
	width: 100%;
	padding: 20px 0;
	display: grid;
	grid-gap: 30px;
	grid-template-columns: 1fr 1fr 1fr 1fr;

	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		display: flex;
		grid-column-gap: unset;
		grid-template-columns: unset;
		overflow-x: scroll;
		padding: 20px;
		-webkit-overflow-scrolling: touch;

		&::-webkit-scrollbar {
			display: none;
		}
	}

	@media screen and (${PAGE_BREAKPOINTS.MOBILE}) {
		overflow-x: scroll;
	}
`

const TopicsTitle = styled.h2``

const TopicsMobileBottom = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 4px;
`

const ShowOnDesktop = styled.div`
	display: block;

	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		display: none;
	}
`

const ShowOnMobile = styled.div`
	display: none;

	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		display: block;
	}
`
